import { Options, Vue } from 'vue-class-component';
import {
  RoomDTO,
  RoomObject,
  RoomObjectDTO,
  RoomObjectType,
} from '@/../client-generator/generated-clients/plants';
import { PropType } from 'vue';
import { getObjectIconFromType, getRoomIconFromType } from '@/core/utils/utils';

type RoomObjectExtended = RoomObject & {
  showBar?: boolean;
};

@Options({
  name: 'RoomAndRoomObjects',
  props: {
    room: {
      type: Object as PropType<RoomDTO>,
      required: true,
    },
    roomObjectType: {
      type: Number as PropType<RoomObjectType>,
      required: true,
    },
    selectedRoomobject: {
      type: Object as PropType<string[]>,
      required: true,
    },
  },
  emits: ['toggle-roomobject'],
})
export default class RoomAndRoomObjects extends Vue {
  room!: RoomDTO;
  roomObjectType!: RoomObjectType;
  selectedRoomobject!: string[];
  isExpanded = false;
  getRoomIconFromType = getRoomIconFromType;
  getObjectIconFromType = getObjectIconFromType;

  get compatibleRoomObjects() {
    return (
      this.room.roomObjects?.filter((k) => k.type === this.roomObjectType) || []
    );
  }
  get compatibleRoomObjectsSelectedCount() {
    return this.compatibleRoomObjects.filter(
      (o) => o.id && this.selectedRoomobject.includes(o.id)
    ).length;
  }

  toggleRoomObject(roomObject: RoomObjectDTO) {
    this.$emit('toggle-roomobject', {
      room: JSON.parse(JSON.stringify(this.room)),
      roomObject: JSON.parse(JSON.stringify(roomObject)),
    });
  }

  toggleExpand() {
    this.isExpanded = !this.isExpanded;
  }
}
